/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ItemResponseType } from './ItemResponseType';
import {
    ItemResponseTypeFromJSON,
    ItemResponseTypeFromJSONTyped,
    ItemResponseTypeToJSON,
    ItemResponseTypeToJSONTyped,
} from './ItemResponseType';

/**
 * 
 * @export
 * @interface StaffItemResponse
 */
export interface StaffItemResponse {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    participant_id: string;
    /**
     * 
     */
    response: ItemResponseType;
    /**
     * 
     */
    note: string | null;
    /**
     * 
     */
    other_contact: string | null;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    updated_at: Date;
}



/**
 * Check if a given object implements the StaffItemResponse interface.
 */
export function instanceOfStaffItemResponse(value: object): value is StaffItemResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('other_contact' in value) || value['other_contact'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function StaffItemResponseFromJSON(json: any): StaffItemResponse {
    return StaffItemResponseFromJSONTyped(json, false);
}

export function StaffItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'participant_id': json['participant_id'],
        'response': ItemResponseTypeFromJSON(json['response']),
        'note': json['note'],
        'other_contact': json['other_contact'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
    };
}

export function StaffItemResponseToJSON(json: any): StaffItemResponse {
    return StaffItemResponseToJSONTyped(json, false);
}

export function StaffItemResponseToJSONTyped(value?: StaffItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participant_id': value['participant_id'],
        'response': ItemResponseTypeToJSON(value['response']),
        'note': value['note'],
        'other_contact': value['other_contact'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

